import { parseNumber } from '../../shared/NumberHelper';
import { formatCurrency } from '../../shared/StringHelper';

const rx = /\{\{(.+?)\}\}/g;

function transform(name: string, value: string): string | undefined {
    switch (name) {
        case 'money':
            return formatCurrency(parseNumber(value));
        default:
            throw new Error(`Unsupported transform: ${name}`);
    }
}

export function renderVariables(content: string | undefined, variables: Record<string, string> | undefined) {
    return content?.replace(rx, (_, def: string) => {
        const [variable, ...transforms] = def.split('|').map((x) => x.trim());
        let result = variables?.[variable] ?? '';
        for (const transformName of transforms) {
            result = transform(transformName, result) ?? '';
        }
        return result;
    });
}
